require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./insights-roshinibakshi.json") })
        }
      }, "path---insights-roshinibakshi");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---insights-roshinibakshi!./.cache/json/insights-roshinibakshi.json
// module id = 1139
// module chunks = 231608221292675